'use client';

import { useStorageKeyPrefix } from './StorageKeyPrefixProvider';
import useStorage_InternalUseOnly, {
  UseStorageOptions,
} from './useStorage_InternalUseOnly';

export default function useSessionStorage<T>(
  key: string,
  fallbackValue: T,
  options: UseStorageOptions = {},
) {
  const prefix = useStorageKeyPrefix();
  const prefixedKey = `${options.customPrefix || prefix}:${key}`;
  const [value, setValue] = useStorage_InternalUseOnly(
    'session',
    prefixedKey,
    fallbackValue,
    options,
  );

  return [value, setValue] as const;
}
